import restoreTimeDefinition from './module/index.js';
import restoreTimePluginDefinition from './plugin/index.js';
import restoreTimeApiDefinition from './api/index.js';
import restoreTimeReportDefinition from './report/index.js';
const restoreTime = () => ({
    id: 'restoreTime',
    definitions: [
        {
            definition: restoreTimeDefinition,
        },
        { definition: restoreTimePluginDefinition },
        { definition: restoreTimeApiDefinition },
        { definition: restoreTimeReportDefinition },
    ],
});
export default restoreTime;
